import React from "react";
import { Text } from "@chakra-ui/react";
import { accent } from "../../constants/constants";

interface ScrollProps {
  to: string;
  label: string;
}

const ScrollComponent: React.FC<ScrollProps> = ({ to, label }) => {
  return (
    <Text
      as="a"
      href={`#${to}`}
      fontFamily="'Montserrat', sans-serif"
      fontWeight={600}
      fontSize="sm"
      letterSpacing="0.05em"
      color="brand.muted"
      whiteSpace="nowrap"
      transition="color 0.2s ease"
      sx={{ writingMode: "vertical-rl" }}
      transform="rotate(180deg)"
      _hover={{ color: accent, textDecoration: "none" }}
    >
      {label}
    </Text>
  );
};

export default ScrollComponent;
